import { redirect, RouteObject } from 'react-router-dom';

import i18n from 'app/i18n';
import { professions } from 'app/services';
import { ModuleLayout } from 'app/layouts';

import Form from './form';
import List from './list';

export const routes: RouteObject[] = [
  { path: 'professions', element: <ModuleLayout />,
    handle: { title: i18n.t('professions.title') },
    children: [
      { path: '', index: true, element: <List />,
        handle: { permission: 'professions:read', exclude: true },
      },
      { path: 'new', element: <Form />,
        handle: { title: i18n.t('professions.new'), permission: 'professions:create' },
      },
      { path: ':id', element: <Form />,
        loader: ({ params: { id } }) => professions.get(id!).then(({ data }) => data ?? redirect('..')),
        handle: { title: (country: any) => (country && i18n.t('professions.edit', country)), permission: 'professions:update' },
      },
    ],
  },
];
